import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { ReactComponent as NotificationBellIcon } from 'src/assets/tailwind/Notifications/notification-icon.svg';
import { EmptyStatePlaceHolder } from 'src/components/ui/empty-state-placehoder';
import { Typography } from 'src/components/ui/typography';
import { NOTIFICATION_RETENTION_DAYS } from '../../constants';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';
import type { AppNotification } from '../../types';
import NotificationRow from '../NotificationRow';
import NotificationSkeleton from '../NotificationSkeleton';

type NotificationPanelBodyProps = {
  notifications: AppNotification[];
  isLoading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
  onDismiss?: (id: number) => void;
  onMarkReadStatus?: (id: number, isRead: boolean) => void;
};

const NotificationPanelBody = ({
  notifications,
  isLoading,
  hasMore,
  onLoadMore,
  onDismiss,
  onMarkReadStatus
}: NotificationPanelBodyProps) => {
  const { t } = useTranslation();

  return (
    <div
      id="notifications-scroll-container"
      className="tw:flex-1 tw:flex tw:flex-col tw:min-h-0 tw:overflow-y-auto"
    >
      {isLoading ? (
        Array.from({ length: 4 }).map((_, i) => <NotificationSkeleton key={i} />)
      ) : notifications?.length === 0 ? (
        <div className="tw:flex-1 tw:flex tw:flex-col tw:items-center tw:justify-center tw:overflow-y-auto">
          <EmptyStatePlaceHolder
            borderless
            icon={NotificationBellIcon}
            title={t(T.allCaughtUp)}
            description={
              t(T.allCaughtUpDescription, { NOTIFICATION_RETENTION_DAYS }) as string
            }
          />
        </div>
      ) : (
        <>
          <InfiniteScroll
            dataLength={notifications?.length ?? 0}
            next={onLoadMore ?? (() => {})}
            hasMore={hasMore ?? false}
            loader={
              <div className="tw:py-2 tw:text-center">
                <Typography variant="b2" colorClass="tw:text-text-disabled">
                  {t(T.loading)}
                </Typography>
              </div>
            }
            scrollableTarget="notifications-scroll-container"
          >
            {notifications?.map((notification) => (
              <NotificationRow
                key={notification?.id}
                notification={notification}
                onDismiss={onDismiss}
                onMarkReadStatus={onMarkReadStatus}
              />
            ))}
          </InfiniteScroll>
        </>
      )}
    </div>
  );
};

export default NotificationPanelBody;
